'use strict';

/**
 * Values for the 'protocol' attribute of a transfers
 *
 * @enum {String}
 */
module.exports = {
  MX_WAN: 'mxwan',
  MX_TCP: 'mxtcp',
  HTTP: 'http'
};